import PropTypes from 'prop-types';
import { useCallback, useContext, useMemo } from 'react';

import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { TRACKING_ACTION, TRACKING_INTERACTION } from 'contexts/AnalyticsContext/Constants';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { CAS_IMG_DEFAULT, MESSAGE_LOGGED, SIGN_IN, URL_IMG_CAS } from 'contexts/CruiseSearchContext/constants';
import { getCookie } from 'lib/utilities/Cookies';
import Link from 'next/link';

import { UserMenuItems } from './sbMockData';

import styled from 'styled-components';
import colors from 'styles/colors';
import media from 'styles/media';

import IconButton from 'components/buttons/IconButton';
import IconFavorites from 'components/svg/IconFavorites';
import IconWatchlist from 'components/svg/IconWatchlist';

const UserOptionsContainer = styled.div`
	display: flex;
	margin-left: 10%;

	${media.medium`
        display: none
    `}
`;

const MenuLink = styled.a`
	display: flex;
	align-items: center;
`;

const ListItem = styled.li`
	color: #ffffff;
	font-size: 12px;
`;
const ImgCAS = styled.img`
	width: 27px;
	height: 30px;
	margin-right: 14px;
`;

const TierText = styled.span`
	max-width: 150px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

/**
 * Placeholder for the real menu
 *
 * @param {array} menuItem - array of objects
 */

const MenuUserOptions = ({ toggleFavorite, toggleWatchlist }) => {
	const { utagFavoritesWatchlistClicked } = useContext(AnalyticsContext);
	const { locale } = useContext(CruiseSearchContext);

	const { FAVORITES_AND_WATCHLIST } = TRACKING_INTERACTION;

	const onRedirect = (path) => {
		window.location.href = path;
	};

	const tierData = useCallback(() => {
		return getCookie('loyaltyData');
	}, [getCookie]);

	const dataTierClient = useMemo(() => {
		let items = [...UserMenuItems];

		const data = Object.fromEntries(
			tierData()
				?.split('|')
				?.map((prop) => {
					const [propName, value] = prop.split('=') ?? null;
					return [propName, value === 'null' ? null : value];
				}) || [],
		);

		if (Object.keys(data).length > 0) {
			items = UserMenuItems.map((item) => {
				let newItem = { ...item };
				if (item.label === SIGN_IN) {
					newItem = {
						...item,
						label: MESSAGE_LOGGED.replace('{{firstName}}', data?.firstName),
						img: URL_IMG_CAS.replace('{{loyaltyLevel}}', data?.loyaltyLevel?.toLowerCase() || '') || CAS_IMG_DEFAULT,
					};
				}
				return newItem;
			});
		}
		return items;
	}, [tierData]);

	const sendEventFavorites = (path) => {
		const interaction = {
			event: TRACKING_ACTION.NAV_CLICKS,
			interaction: FAVORITES_AND_WATCHLIST.CLICK_FAVORITE_HEADER,
			extra: {
				country: locale?.country,
				language: locale?.language,
			},
		};
		utagFavoritesWatchlistClicked(interaction, () => onRedirect(path));
	};

	return (
		<UserOptionsContainer>
			{toggleFavorite && (
				<IconButton
					id="rciFavoritesHeaderIcon"
					className="iconButton"
					icon={<IconFavorites color={colors.primary.ice} />}
					onClick={() => sendEventFavorites('/favorites')}
				/>
			)}
			{toggleWatchlist && (
				<Link href={'/watchlist'}>
					<IconButton id="rciWatchlistHeaderIcon" className="iconButton" icon={<IconWatchlist color={colors.primary.ice} />} />
				</Link>
			)}
			{dataTierClient.map((menuItem) => {
				return (
					<ListItem key={menuItem.label}>
						<MenuLink id={menuItem.id} href={menuItem.path} target={menuItem.target}>
							{menuItem.img && <ImgCAS src={menuItem.img} alt="CAS" />}
							<TierText>{menuItem.label}</TierText>
						</MenuLink>
					</ListItem>
				);
			})}
		</UserOptionsContainer>
	);
};

MenuUserOptions.propTypes = {
	toggleFavorite: PropTypes.bool,
	toggleWatchlis: PropTypes.bool,
};

export default MenuUserOptions;
